const validRunDetailsTabs = ['charts', 'attributes', 'dashboard'];

export function isValidRunDetailsTab(tab?: string): boolean {
  return tab != null && validRunDetailsTabs.includes(tab);
}
